<script>
import { mapGetters } from 'vuex'
import { getYear } from 'date-fns'

export default {
  props: {
    property: { type: Object, required: true },
  },
  data() {
    return {
      year: getYear(new Date()),
    }
  },
  computed: {
    ...mapGetters('cart/rooms', { cartRooms: 'isEmpty' }),
    socialmedia() {
      const {
        instagram,
        facebook,
        twitter,
        youtube,
      } = this.property.socialMediaLinks

      return [
        { icon: 'instagram', link: instagram },
        { icon: 'facebook-square', link: facebook },
        { icon: 'twitter', link: twitter },
        { icon: 'youtube', link: youtube },
      ]
    },
  },
}
</script>

<template>
  <footer class="footer">
    <section class="bg-gray-300">
      <div class="container container-page mx-auto px-6 pt-6">
        <div class="flex flex-wrap -mx-3">
          <div class="w-full md:w-1/3 px-3 mb-6">
            <p class="text-xs">
              {{ property.description }}
            </p>
          </div>

          <div class="w-full md:w-1/3 px-3 mb-6">
            <iframe
              class="border-none w-full md:h-32"
              frameborder="0"
              :src="property.address.embedMap"
              allowfullscreen
            ></iframe>
          </div>

          <div class="w-full md:w-1/3 px-3 mb-6">
            <p class="mb-6 text-xs">
              <span class="text-sm font-medium"> {{ property.name }} </span><br />
              {{ property.address.line }}<br />
              {{
                `${property.address.city}, ${property.address.state} ${property.address.zip
                }`
              }}<br />
              Tel: {{ property.phone }}
            </p>
            <ul class="text-3xl leading-none">
              <li
                v-for="media in socialmedia"
                :key="media.icon"
                class="inline-block mr-3 hover:text-gold-500"
              >
                <a :href="media.link || '#'" target="_blank">
                  <span>
                    <i class="fab" :class="`fa-${media.icon}`"></i>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-gray-900">
      <div
        class="container container-page mx-auto pt-4 md:pb-4 px-6"
        :class="cartRooms || $route.name === 'property-booking' ? 'pb-4' : 'pb-20'
          "
      >
        <p class="text-gray-600">
          Copyright © {{ year }} Kamandalu Ubud. All rights reserved.
        </p>
      </div>
    </section>
  </footer>
</template>
